"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const seamless_immutable_1 = __importDefault(require("seamless-immutable"));
const RedeemActions_1 = __importDefault(require("../actions/RedeemActions"));
const RedeemSource_1 = __importDefault(require("../sources/RedeemSource"));
const epic_react_common_1 = require("epic-react-common");
const decorators_1 = require("alt-utils/lib/decorators");
const common_1 = require("@epic-core/common");
const window_or_global_1 = __importDefault(require("window-or-global"));
const epic_alt_utils_1 = require("epic-alt-utils");
const talon_1 = __importDefault(require("../utils/talon"));
let RedeemStore = class RedeemStore {
    constructor() {
        this.on('error', error => {
            console.error(error);
        });
        this.state = seamless_immutable_1.default({
            currentStage: 'VALIDATE',
            redeemComplete: false,
            nextStage: '',
            redeemCode: '',
            title: '',
            description: '',
            isInvalidCode: null,
            validationError: null,
            requireEula: false,
            redeemError: null,
            loading: false,
            entitlementName: []
        });
        this.bindActions(RedeemActions_1.default);
    }
    startCaptcha(talonFlowId, callback) {
        talon_1.default({
            flow: talonFlowId,
            onSuccess: captchaToken => {
                if (captchaToken) {
                    this.setState(this.state.merge({
                        captchaToken
                    }));
                    callback();
                }
                else {
                    callback();
                }
            },
            onFailed: () => {
                this.setState(this.state.merge({
                    confirmError: { message: 'errors.com.epicgames.common.server_error' },
                    loading: false
                }, { deep: true }));
            },
            onCancel: () => {
                this.setState(this.state.merge({
                    loading: false
                }, { deep: true }));
            }
        });
    }
    onValidateCode(codeData) {
        const { codeInput, isLoggedIn, talonFlowId } = codeData;
        if (isLoggedIn) {
            this.setState(this.state.merge({
                redeemCode: codeInput,
                loading: true,
                talonFlowId
            }));
            if (talonFlowId) {
                this.startCaptcha(talonFlowId, this.getInstance().validateCode);
            }
            else {
                this.getInstance().validateCode();
            }
        }
        else {
            this.setState(this.state.merge({
                currentStage: 'LOGIN'
            }));
        }
    }
    onValidateCodeSuccess(response) {
        const newState = { loading: false };
        if (response.data.isSuccess) {
            newState.currentStage = this.state.nextStage;
            newState.isInvalidCode = false;
            newState.title = response.data.data.title;
            newState.description = response.data.data.description;
            newState.entitlementName = response.data.data.entitlementName;
        }
        else {
            // error handling
            newState.validationError = response.data;
            newState.isInvalidCode = true;
        }
        newState.isCaptachaSolved = response.data.isCaptachaSolved;
        this.setState(this.state.merge(newState));
    }
    onValidateCodeFailure() {
        this.setState(this.state.merge({
            isInvalidCode: true,
            loading: false
        }));
    }
    onRedeemCode(data) {
        if (data.isLoggedIn) {
            this.setState(this.state.set('loading', true));
            const callback = () => {
                this.getInstance().redeemCode(data);
            };
            if (this.state.talonFlowId && !this.state.isCaptachaSolved) {
                this.startCaptcha(this.state.talonFlowId, callback);
            }
            else {
                callback();
            }
        }
        else {
            this.setState(this.state.set('currentStage', 'LOGIN'));
        }
    }
    onRedeemCodeSuccess(response) {
        if (response.data.isSuccess) {
            this.setState(this.state.merge({
                currentStage: this.state.nextStage,
                redeemComplete: true,
                loading: false
            }));
        }
        else {
            this.setState(this.state.merge({
                redeemError: response.data,
                loading: false
            }));
        }
    }
    onRedeemCodeFailure() {
        this.setState(this.state.set('loading', false));
    }
    onClearEntitlementsFromSession() {
        this.getInstance().clearEntitlementsFromSession();
    }
    setNextStage(nextStage) {
        this.setState(this.state.set('nextStage', nextStage));
    }
    setCurrentStage(stage) {
        this.setState(this.state.set('currentStage', stage));
    }
    resetFlow() {
        this.setState(this.state.merge({
            currentStage: 'VALIDATE',
            nextStage: '',
            redeemCode: '',
            isInvalidCode: null,
            validationError: null,
            requireEula: false,
            redeemError: null,
            loading: false
        }));
    }
    onRequestLogin(returnPath) {
        const [returnPathname, searchParams] = returnPath === null || returnPath === void 0 ? void 0 : returnPath.split('?');
        const redirectURLParams = new URLSearchParams(searchParams || '');
        if (!redirectURLParams.has('lang')) {
            redirectURLParams.set('lang', common_1.getLocale());
        }
        const loginUrl = `${window_or_global_1.default.appContext || ''}/login?${new URLSearchParams({
            lang: common_1.getLocale(),
            redirectTo: `${returnPathname !== null && returnPathname !== void 0 ? returnPathname : window_or_global_1.default.location.pathname}?${redirectURLParams}`
        })}`;
        window_or_global_1.default.location.href = loginUrl;
    }
    onRequestRegister(options) {
        this.onRequestLogin(options);
    }
};
RedeemStore = __decorate([
    decorators_1.datasource(RedeemSource_1.default),
    epic_alt_utils_1.seamlessImmutable,
    __metadata("design:paramtypes", [])
], RedeemStore);
exports.default = epic_react_common_1.alt.createStore(RedeemStore, 'RedeemStore');
//# sourceMappingURL=RedeemStore.js.map